<cvc-enum-select
  [cvcFormControl]="formControl"
  [cvcFormlyAttributes]="field"
  [cvcSelectMode]="props.isMultiSelect ? 'multiple' : 'default'"
  [cvcPlaceholder]="props.placeholder"
  [cvcCustomTemplate]="selectedTemplate"
  [cvcOptions]="selectOption$ | ngrxPush"
  [cvcShowError]="showError"
  [cvcDisabled]="props.disabled"></cvc-enum-select>
<ng-container *ngFor="let enum of levelEnum$ | ngrxPush; index as i">
  <ng-template #optionTemplates>
    <nz-tag>
      <strong>{{ enum }}</strong> - {{ enum | enumTooltip: 'evidenceLevelBrief'
      }}
    </nz-tag>
  </ng-template>
</ng-container>

<ng-template
  #selectedTemplate
  let-selected>
  <div class="ant-select-selection-item-content">
    <nz-tag
      *ngIf="!props.isMultiSelect"
      nzMode="closeable"
      (nzOnClose)="onTagClose$.next($event)">
      <strong>{{ selected.nzValue }}</strong> - {{ selected.nzValue |
      enumTooltip: 'evidenceLevelBrief' }}
    </nz-tag>
    <ng-container *ngIf="props.isMultiSelect">
      <strong>{{ selected.nzValue }}</strong> - {{ selected.nzValue |
      enumTooltip: 'evidenceLevelBrief' }}
    </ng-container>
  </div>
</ng-template>
